Enterprise = require 'app/scripts/models/enterprise'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'

class EnterpriseList extends CollectionWithHelpers
  model: Enterprise

  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (enterprise) ->
    enterprise.get('name')

module.exports = EnterpriseList
